<div id="event-detail-container">
  <div id="toggle-label">
    <button
      type="button"
      class="toggle-button-open w-100 h-100 text-dark"
      aria-label="Close"
      (click)="toggleSize()"
      (keydown.enter)="toggleSize()">
      <h3>{{ isBig ? '−' : '+' }}</h3>
    </button>
  </div>
  <app-terminal-event-detail-toggler
    [data$]="mappedData$"
    [configurationFileName]="configurationFileName"
    [eventName]="eventName"
    [selectedFilters$]="selectedFilters$"
    (detailAttributeChanged)="selectFilter($event)"
    (jump)="jumpTo($event)"
    (reset)="resetView()"></app-terminal-event-detail-toggler>
</div>
